import SDIcon from '../SDIcon'

const IconLocationCompany = ({ size = 32, ...props }) => (
  <SDIcon title='Location company' {...props} size={size}>
    <path
    d='M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z'
    fill='currentColor'
    />
    <path
    d='M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z'
    fill='currentColor'
    />
    <rect x='15' y='16' width='2' height='2' fill='currentColor' />
    <rect x='15' y='12' width='2' height='2' fill='currentColor' />
    <rect width='32' height='32' fill='none' />
  </SDIcon>
)

export default IconLocationCompany
